import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface ITag extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string | null;
  };
}

export type Tag = Entity<ITag>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Tag: IEntityType<ITag> = vmClient.defineClass({
  typeName: 'Tag',
  version: 2,
  persisted: true,
  attributes: {
    name: 'string',
  },
});
